<!-- 杠杆资金 -->
<template>
  <div class="dbcaptial-wrap">
    <vue-loading 
      v-if="isshowloading"
      style="margin-top: 60px;"
      type="bars" 
      color="#d9544e" 
      :size="{ width: '50px', height: '50px' }"
    ></vue-loading>
    <div class="tabs">
      <div
        v-for="(item, i) in tab.text"
        :ref="'lf' + i"
        :class="['tab', i === tab.index  && 'active']"
        :key=i
        @click="tab.index = i;changetab()"
      >{{item}}</div>
      <div :ltip="szmessage" class="tips"></div>
    </div>

    <div class="chart-1">
      <ChartTpl
        :enableResize='true'
        :elementId='"dbcaptialCircle"'
        :width='"100%"'
        :height='"120px"'
        :option='circleOption'
        :originData='circleData'
      ></ChartTpl>
    </div>
    <div class="chart debug">
      <!-- {{tab.text[tab.index]}}的图 -->
      <ChartTpl
        v-show="tab.index === 0"
        :elementId='"leverageLine0"'
        ref="leverageLine0"
        :firstTooltip='true'
        :enableResize='true'
        :width='"100%"'
        :height='"248px"'
        :option='line0Option'
        :originData='line0Data'
        ></ChartTpl>
      
      <template v-if="alreadyLoad1">
        <ChartTpl
          v-show="tab.index === 1"
          :elementId='"leverageLine1"'
          ref="leverageLine1"
          :firstTooltip='true'
          :enableResize='true'
          :width='"100%"'
          :height='"248px"'
          :option='line1Option'
          :originData='line1Data'
        ></ChartTpl>
      </template>

      <template v-if="alreadyLoad2">
        <ChartTpl
          v-show="tab.index === 2"
          :elementId='"leverageLine2"'
          ref="leverageLine2"
          :firstTooltip='true'
          :enableResize='true'
          :width='"100%"'
          :height='"248px"'
          :option='line2Option'
          :originData='line2Data'
        ></ChartTpl>
      </template>

    </div>

  </div>
</template>

<script>
import ChartTpl from '@/components/ChartTpl.vue';
import { VueLoading } from 'vue-loading-template';

export default {
  name: "LeveragedFunds",
  components: {
    ChartTpl,
    VueLoading
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    leverageMoney:{
      type: Object,
      default: function () {
        return {}
      }
    },
    leverageMoneySeries:{
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      tab: {
        index: 0,
        text: ["杠杆资金", "增持资金", "回购资金"]
      },
      chart: {},
      szmessage: '杠杆资金：将借到的货币追加到用于投资的现有资金上',
      circleOption: {},
      circleData:[],
      line0Option: {},
      line0Data: [],
      line1Option: {},
      line1Data:[],
      line2Option: {},
      line2Data:[],
      alreadyLoad1: false,
      alreadyLoad2: false,
      increaseMoneySeries: [],
      backBuyMoneySeries: [],
      isshowloading: false
    };
  },
  watch: {
    increaseMoneySeries:{
      handler(newvalue, oldvalue){
        this.initLine2();
      }
    },
    backBuyMoneySeries:{
      handler(newvalue, oldvalue){
        this.initLine3();
      }
    },
    leverageMoneySeries: {
      handler(newvalue, oldvalue){
        this.init();
      }
    },
    'tab.index':{
      handler(newvalue, oldvalue){
        let alreadyLoadStr = 'alreadyLoad'+newvalue;
        let getDataStr = 'getData'+newvalue;

        if (newvalue !== 0) {
          if(!this[alreadyLoadStr]) this[getDataStr]();
          this[alreadyLoadStr] = true;
        }

        setTimeout(()=>{
          this.$refs['leverageLine'+newvalue].resize();
        })
      }
    }
  },
  mounted() {
    this.report()
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();

    if(!this.leverageMoneySeries.length) return;
    this.init();
  },
  methods:{
    report () {
      let ta = [{ id: 'pcweb_hgdata_ggzj' }, { id: 'pcweb_hgdata_zczj' }, { id: 'pcweb_hgdata_hgzj' }]
      for (let i = 0; i < 3; i++) {
        let elm = this.$refs['lf'+i][0]
        TA.logElementClick(elm, ta[i])
      }
    },
    changetab(){
      if(this.tab.index == 0)
      {
        this.szmessage = '杠杆资金：将借到的货币追加到用于投资的现有资金上'
      }
      if(this.tab.index == 1)
      {
        this.szmessage = '增持资金：增加持有股票对应的金额'
      }
      if(this.tab.index == 2)
      {
        this.szmessage = '回购资金：上市公司利用现金等方式，从股票市场上购回该公司发行在外的一定数额的股票的行为'
      }
    },
    getData1(){
      this.isshowloading = true;
      this.$api.blockAPI
        .getIncreaseMoneySeries()
        .then(res => {
          if (res.code === 0) {
            this.increaseMoneySeries = res.data.increaseMoneySeries;
            this.isshowloading = false;
          }
        })
        .catch(e => {});
    },
    getData2(){
      this.isshowloading = true;
      this.$api.blockAPI
        .getBackBuyMoneySeries()
        .then(res => {
          if (res.code === 0) {
            this.backBuyMoneySeries = res.data.backBuyMoneySeries;
            this.isshowloading = false;
          }
        })
        .catch(e => {});
    },
    initCircle(){

      let { leverageMoney, increaseMoney, backBuyMoney } = this.leverageMoney;
      this.circleOption = this.$chartConfigs.threeCircle();
      this.circleOption.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: '杠杆资金',
          values: [
            {
              value: leverageMoney.percentile ,
              show: leverageMoney.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: '增持资金',
          values: [
            {
              value: increaseMoney.percentile,
              show: increaseMoney.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: '回购资金',
          values: [
            {
              value: backBuyMoney.percentile,
              show: backBuyMoney.value 
            }
          ]
        }]
      };

      this.circleData = this.circleOption.data;
    },
    initLine(){
      this.line0Option = this.$chartConfigs.line1({
        name: '杠杆资金',
        dataKey: 'financing_balance_money'
      });
      this.line0Data = [{
        originData: this.leverageMoneySeries
      }]
    },
    initLine3(){
      this.line2Option = this.$chartConfigs.line1({
        name: '回购资金',
        dataKey: 'back_buy_money'
      });
      this.line2Data = [{
        originData: this.backBuyMoneySeries
      }]
    },
    initLine2(){
      this.line1Option = this.$chartConfigs.line1({
        name: '增持资金',
        dataKey: 'increase_money'
      });
      this.line1Data = [{
        originData: this.increaseMoneySeries
      }]
    },
    init(){
      this.initLine();
      this.initCircle();
    }
  }
};
</script>

<style scoped>

.dbcaptial-wrap {
  font-size: 14px;
  display: flex;
  flex-direction: column;
}
.tabs {
  display: flex;
  margin-bottom: 10px;
  flex: 0 0 auto;
  align-items: center;
  /* font-weight: 700; */
}
.tab {
  border: 1px solid #3b3c41;
  padding: 2px 12px;
  margin-left: -1px;
  cursor: pointer;
}
.tab.active {
  background: #3b3c41;
  color: #fff;
  cursor: default;
}

.chart-1 {
  height: 120px;
  flex: 0 0 auto;
  margin-bottom: 1px;
}

.chart {
  flex: 1 1 auto;
}
.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:24px;
  height: 16px;
}
.vue-loading {
  position: absolute;
  top: 50%;
  left: 40%;
  z-index: 9999;
}
</style>
